export default { sha: 'd942999fc17917c80f2cf08c2343f0a51640147d', buildNumber: 'undefined' }
